import { Chip } from "@legal-500/legal500-design-system";
import type { AwardShortlistTag, AwardStatus } from "../../../api/awards.types.js";
import { AwardStatusChip } from "./AwardStatusChip.js";
import styles from "./AwardsCells.module.css";

const SHORTLIST_TAG_LABELS: Record<AwardShortlistTag, string> = {
  predicted_winner: "Predicted winner",
  runner_up: "Runner-up",
};

type StatusCellProps = {
  status: AwardStatus;
  shortlistTag: AwardShortlistTag | null;
};

/**
 * "Status" — the status chip, with the shortlist tag underneath when the row
 * carries one. Only a shortlisted row can, so the second chip qualifies the
 * first rather than competing with it; with no tag there is no second element
 * at all, for the reason TypeCategoryCell gives about its empty second line.
 */
export function StatusCell({ status, shortlistTag }: StatusCellProps) {
  return (
    <div className={styles.statusCell}>
      <AwardStatusChip status={status} />
      {shortlistTag !== null && (
        <Chip size="small" variant="filled" className={styles.shortlistTag}>
          {SHORTLIST_TAG_LABELS[shortlistTag]}
        </Chip>
      )}
    </div>
  );
}
